module.exports = __webpack_public_path__ + "img/weather67.76447e81.png";